import Vue from 'vue';
import Router from 'vue-router';
import NotFound from '@/components/core/core_page/404.vue';
import Home from './views/Home.vue';
import otpRouter from './otpRouter';
import bmsRouter from './bmsRouter';
import tmsRouter from './tmsRouter';
import lsrmRouter from './lsrmRouter';
import Report from './report.vue';
import Ams from './Ams.vue';
import Cop from './microApp/cop.vue';
import Cci from './microApp/cci.vue';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

export const routeConfig = [
    {
        path: '/',
        component: Home,
        hidden: false,
        name: 'transport',
        children: [
            ...otpRouter,
            ...bmsRouter,
            ...tmsRouter,
            ...lsrmRouter,
            {
                path: '/redirect/:path*',
                component: () => import('./views/redirect/index.vue'),
            },
            {
                path: '/',
                redirect: '/index'
            },
            {
                fdId: '1',
                path: '/index',
                name: 'index',
                meta: { title: '工作台', icon: 'dispatchPopup' },
                component: () => import('./views/manageDesk/Index.vue')
            },
            {
                path: '/storeWorkbench',
                name: 'storeWorkbench',
                meta: { title: '仓储工作台', icon: 'dispatchPopup' },
                component: () => import('./views/storeWorkbench/Index.vue')
            },
            {
                path: `/user-center`,
                name: 'userCenter',
                component: () => import('@/components/awesome/page/userCenter/UserCenter.vue'),
                meta: {
                    title: 'system.route.userCenter'
                }
            },
            {
                path: '/report/*',
                name: 'report',
                component: Report,
                meta: {
                    title: '报表系统'
                }
            },
            {
                path: '/outPage/*',
                name: 'ams',
                component: Ams,
                meta: {
                    title: '异常罚扣',
                }
            },
            {
                path: '/app-cop/:page*',
                name: 'app-cop',
                component: Cop,
                meta: {
                    title: '工单',
                    system: 'cci',
                }
            },
            {
                path: '/app-cci/:page*',
                name: 'app-cci',
                component: Cci,
                meta: {
                    title: '问题件',
                }
            },
            {
                path: '/*',
                name: 'notFound',
                component: NotFound
            }
        ]
    }
];

export default new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: routeConfig
});
